import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// JR drops the History namespace; the wire type is setting-versions.
const SettingVersionSchema = withDefaults({
  type: 'setting-version',
  traits: ['version'],
  fields: [],
});

export default SettingVersionSchema;
